import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Configure Axios to include credentials with requests
axios.defaults.withCredentials = true;

dayjs.extend(utc);
dayjs.extend(timezone);

const DubaiDateTime = new Date().toLocaleString("en-US", {
  timeZone: "Asia/Dubai",
});

let system_dt = dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss");

// Create an Axios instance with a base URL and default headers
export default axios.create({
  baseURL: document.getElementById("backend_url").value, // Use this for local development
  headers: {
    "system-dt":
      document.getElementById("crm_countries").value === "UAE"
        ? dayjs(DubaiDateTime).format("YYYY-MM-DD HH:mm:ss")
        : system_dt, // Example of a custom static header
  },
});
